import React from 'react';
import { PageHeader } from '../../../../shared/components/patterns';

export default function DocumentsHeader() {
  return (
    <PageHeader
      title="Documenti"
      description="Gestione centralizzata dei documenti aziendali"
    />
  );
}
